import { $t } from '@/utils/languageAuto';
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import LogList from './logList.vue';
import AmountList from './amountList.vue';
import { loading } from '@/decorators';

var ViewDetail = function (_super) {
  __extends(ViewDetail, _super);

  function ViewDetail() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.tabList = [{
      value: 'amountList',
      text: _this.t('费用明细')
    }, {
      value: 'logList',
      text: _this.t('流水日志')
    }];
    _this.loadingStatus = false;
    _this.activeName = _this.tabList[0].value;
    _this.detailsData = {};
    return _this;
  }

  ViewDetail.prototype.created = function () {};

  ViewDetail.prototype.handleCancel = function () {
    this.$emit('update:visible', false);
  };

  ViewDetail.prototype.handleVisible = function () {
    if (this.visible) {
      this.activeName = this.tabList[0].value;
      this.queryDetails();
    }
  };

  ViewDetail.prototype.queryDetails = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, order_create_time, order_number, params, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.detailsData = {};
            _a = this.rowData, order_create_time = _a.order_create_time, order_number = _a.order_number;
            params = {
              order_create_time: order_create_time,
              order_number: order_number
            };
            return [4, this.$api.finance.queryHwcStatementDetails(params)];

          case 1:
            data = _b.sent().data;
            this.detailsData = data || {};
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: String,
    "default": false
  })], ViewDetail.prototype, "visible", void 0);

  __decorate([Prop({
    type: Object,
    "default": function _default() {}
  })], ViewDetail.prototype, "rowData", void 0);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], ViewDetail.prototype, "handleVisible", null);

  __decorate([loading('loadingStatus')], ViewDetail.prototype, "queryDetails", null);

  ViewDetail = __decorate([Component({
    components: {
      LogList: LogList,
      AmountList: AmountList
    }
  })], ViewDetail);
  return ViewDetail;
}(Vue);

export default ViewDetail;